/**
 * "00 hour 01 minutes 32 seconds" -> "1m 32s".
 *
 * Both motor and property send `time_taken_to_upload` pre-formatted as this
 * exact sentence (singular/plural spelling included) — there is no raw
 * seconds count to work from, so this parses the sentence rather than
 * re-deriving it. Zero-valued units are dropped so a short upload doesn't
 * read "0h 1m 32s" in a header that's already tight on space.
 */
export const formatUploadDuration = (raw) => {
  const match = /(\d+)\s*hours?\s*(\d+)\s*minutes?\s*(\d+)\s*seconds?/i.exec(
    String(raw || ""),
  );
  if (!match) return raw || "";

  const [, h, m, s] = match.map(Number);
  const parts = [];
  if (h) parts.push(`${h}h`);
  if (m) parts.push(`${m}m`);
  if (s || parts.length === 0) parts.push(`${s}s`);
  return parts.join(" ");
};

export default formatUploadDuration;
